import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React, { FC } from "react";

import { HeroBannerProps } from "./hero-banner";
import { HeroBannerVariants, MediaLayoutValues } from "./types";

export interface HeroBannerMediaProps extends Pick<HeroBannerProps, "tagVariant" | "mediaFit"> {
  media: {
    mimeType: string;
    gatsbyImageData: IGatsbyImageData | null;
    placeholderUrl: string | null;
    url: string | null;
  } | null;
  alt: string | null;
  backgroundImageUrl?: string;
  isProduct?: boolean;
}

export const HeroBannerMedia: FC<HeroBannerMediaProps> = ({
  alt,
  media,
  mediaFit,
  backgroundImageUrl,
  tagVariant,
  isProduct,
}) => {
  const mediaFitValue =
    mediaFit === MediaLayoutValues.CONTAIN ? "contain" : isProduct ? "contain" : "cover";

  return (
    <div className="absolute w-full h-full bg-white">
      {media && /^image\/*/g.test(media.mimeType) && media.gatsbyImageData && (
        <GatsbyImage
          image={media.gatsbyImageData}
          alt={alt ?? ""}
          objectFit={mediaFitValue ?? "cover"}
          className="w-full h-full"
          loading={tagVariant === HeroBannerVariants.h1 ? "eager" : "lazy"}
        />
      )}
      {media && /^video\/*/g.test(media.mimeType) && media.url && (
        <video
          src={media.url}
          controls={false}
          controlsList="nofullscreen"
          autoPlay
          muted
          loop
          preload="auto"
          className={`object-${mediaFitValue} object-center h-full w-full filter-0`}
        />
      )}
      {backgroundImageUrl && (
        <img src={backgroundImageUrl} alt={alt ?? ""} className="w-full h-full object-cover" />
      )}
    </div>
  );
};
